import axios from '../axios'

/* 
 * 主题推荐模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/theme/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/theme/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/theme/findPage',
        method: 'post',
        data
    })
}
export const findPageAll = (data) => {
    return axios({
        url: '/theme/findPageAll',
        method: 'post',
        data
    })
}

export const getSort = (data) => {
    return axios({
        url: '/theme/getSort',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/theme.js